import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  MenuItem,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import axios from "axios";
import Swal from "sweetalert2";

import CustomInput from "../../../shared/utils/Input";
import GlobalButton from "../../../shared/utils/GlobalButton";
import GlobalDropdownField from "../../../shared/utils/GlobalDropdownField";
import MinMaxFileUploader from "../../../shared/utils/minmaxFileUploader";
import Styles from "../../../styles/vendorDashboard.module.css";
import { Cross } from "../../../shared/assets/icons";
import { statecityData } from "../../../shared/enums";

/* ❌ Super Admin REMOVED */
const ALL_STATES_LIST = statecityData.map((s) => s.name);
const roleOptions = [
  { value: 0, label: "Client Servicing Manager" },
  { value: 1, label: "Business Development" },
  { value: 2, label: "Management Trainee" },
  { value: 3, label: "Purchase" },
  { value: 4, label: "Operations Manager" },
  { value: 5, label: "IP Manager" },
  { value: 6, label: "Store Onboarding Executive" },
  { value: 7, label: "Designer Manager" },
];
const ZONE_OPTIONS = [
  { value: "north", label: "North" },
  { value: "south", label: "South" },
  { value: "east", label: "East" },
  { value: "west", label: "West" },
];

export const ZONE_STATE_MAP = {
  north: [
    // North + Central + UTs
    "Delhi",
    "Haryana",
    "Punjab",
    "Uttar Pradesh",
    "Uttarakhand",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Ladakh",
    "Chandigarh",
    "Madhya Pradesh",
    "Chhattisgarh",
  ],

  south: [
    // Proper South
    "Tamil Nadu",
    "Karnataka",
    "Kerala",
    "Telangana",
    "Andhra Pradesh",
    "Puducherry",
    "Lakshadweep",
  ],

  west: [
    // West + UTs
    "Maharashtra",
    "Gujarat",
    "Rajasthan",
    "Goa",
    "Dadra and Nagar Haveli and Daman and Diu",
  ],

  east: [
    // East + North-East + Islands
    "West Bengal",
    "Odisha",
    "Bihar",
    "Jharkhand",
    "Sikkim",
    "Assam",
    "Arunachal Pradesh",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Tripura",
    "Andaman and Nicobar Islands",
  ],
};

const UserOnboardingForm = ({
  isModalOpen,
  setIsModalOpen,
  selectedUserData = {},
  setSelectedUserData,
  getUserList,
  setSnackbar,
}) => {
  console.log(selectedUserData);
  const serverURL = process.env.REACT_APP_URL;

  /* ---------------- FORM STATE ---------------- */
  const [formData, setFormData] = useState({
    name: selectedUserData?.name || "",
    email: selectedUserData?.email || "",
    phoneNumber: selectedUserData?.phoneNumber || "",
    role: selectedUserData?.role ?? "",
    experience: selectedUserData?.experience || "",
    profilePhoto: selectedUserData?.profilePhoto || "",
    password: selectedUserData?.password || "",
    // 👇 IP Manager only
    zone: selectedUserData?.zone || "",
    state: selectedUserData?.state || "",
    city: selectedUserData?.city || "",
    address: selectedUserData?.address || "",
  });
  const [cityList, setCityList] = useState([]);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  /* ---------------- HANDLERS ---------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name is required";

    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email";

    if (!formData.phoneNumber || !/^\d{10}$/.test(formData.phoneNumber))
      newErrors.phoneNumber = "Valid phone number required";

    if (formData.role === "") newErrors.role = "Role is required";

    if (!selectedUserData?._id && !formData.password)
      newErrors.password = "Password is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.address) newErrors.address = "Address is required";

    if (isIpManager && !formData.zone) {
      newErrors.zone = "Zone is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    setIsModalOpen(false);
    // setSelectedUserData({});
    setErrors({});
  };
  const isIpManager = Number(formData.role) === 5;
  useEffect(() => {
    if (!isIpManager) {
      setFormData((prev) => ({
        ...prev,
        zone: "",
      }));
    }
  }, [formData.role]);
  useEffect(() => {
    const fetchCitiesByState = async () => {
      if (!formData.state) {
        setCityList([]);
        return;
      }

      try {
        const stateCode = statecityData.find(
          (s) => s.name === formData.state,
        )?.iso2;

        if (!stateCode) return;

        const headers = new Headers();
        headers.append(
          "X-CSCAPI-KEY",
          process.env.REACT_APP_FETCH_STATE_CITY_API_KEY,
        );

        const response = await fetch(
          `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
          { headers },
        );

        const data = await response.json();

        setCityList(
          data.map((c) => ({
            value: c.name,
            label: c.name,
          })),
        );
      } catch (error) {
        console.error("City fetch error", error);
        setCityList([]);
      }
    };

    fetchCitiesByState();
  }, [formData.state]);

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = async (e) => {
    console.log("console.");
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        title: "Validation Error",
        text: "Please fix the errors",
        icon: "error",
        didOpen: () => {
          const swal = document.querySelector(".swal2-container");
          if (swal) swal.style.zIndex = 20000;
        },
      });
      return;
    }
    console.log("try block");
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");

      const payload = {
        ...formData,
      };

      if (selectedUserData?._id) {
        // UPDATE USER
        await axios.put(`${serverURL}/users/${selectedUserData._id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setSnackbar({
          open: true,
          message: "User updated successfully",
          severity: "success",
        });
      } else {
        // CREATE USER
        await axios.post(`${serverURL}/users/add`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setSnackbar({
          open: true,
          message: "User created successfully",
          severity: "success",
        });
      }

      setIsModalOpen(false);
      getUserList();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong",
        icon: "error",
        backdrop: true,
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex = 20000;
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  /* ---------------- RENDER ---------------- */
  return (
    <Dialog open={isModalOpen} maxWidth="xl">
      <div className={`flex justify-between ${Styles.vendorModalColor}`}>
        <DialogTitle>
          <span className="text-lg md:text-2xl font-bold">
            {selectedUserData?._id ? "Edit User" : "Add User"}
          </span>
        </DialogTitle>
        <div className="mx-5 my-4 cursor-pointer" onClick={handleClose}>
          <Cross />
        </div>
      </div>

      <DialogContent className={Styles.vendorModalColor}>
        <form>
          <div className={Styles.formstyling}>
            <h4 className="mb-4 font-bold text-xl">Basic Details</h4>

            <Grid container spacing={4}>
              <Grid item xs={12} sm={6} md={4}>
                <CustomInput
                  name="name"
                  title="Name *"
                  size="small"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  error={errors.name}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <CustomInput
                  name="email"
                  size="small"
                  title="Email *"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  error={errors.email}
                  disabled={!!selectedUserData?._id}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <CustomInput
                  name="phoneNumber"
                  size="small"
                  title="Phone Number *"
                  placeholder="Enter Phone"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  error={errors.phoneNumber}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <CustomInput
                  name="password"
                  title="Password *"
                  size="small"
                  type="password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  error={errors.password}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <GlobalDropdownField
                  name="role"
                  label="Role *"
                  size="small"
                  value={formData.role}
                  onChange={handleInputChange}
                  placeholder="Select Role"
                  options={roleOptions}
                  error={errors.role}
                  renderValueFn={(selected) => {
                    const role = roleOptions.find((r) => r.value === selected);
                    return role ? role.label : "Select Role";
                  }}
                  renderMenuItem={(opt) => (
                    <MenuItem
                      key={opt.value}
                      value={opt.value}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      {opt.label}
                      {formData.role === opt.value && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <CustomInput
                  name="experience"
                  title="Experience (Years)"
                  placeholder="Enter Experience"
                  size="small"
                  value={formData.experience}
                  onChange={handleInputChange}
                />
              </Grid>
              {/* ZONE – only for IP Manager */}
              {isIpManager && (
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="zone"
                    label="Zone *"
                    size="small"
                    value={formData.zone}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        zone: e.target.value,
                        state: "",
                        city: "",
                      })
                    }
                    placeholder="Select Zone"
                    options={ZONE_OPTIONS}
                    error={errors.zone}
                  />
                </Grid>
              )}

              {/* STATE – always visible */}
              <Grid item xs={12} sm={6} md={4}>
                <GlobalDropdownField
                  name="state"
                  label="State *"
                  size="small"
                  value={formData.state}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      state: e.target.value,
                      city: "",
                    })
                  }
                  placeholder="Select State"
                  options={
                    isIpManager && formData.zone
                      ? ZONE_STATE_MAP[formData.zone]?.map((s) => ({
                          value: s,
                          label: s,
                        }))
                      : ALL_STATES_LIST.map((s) => ({
                          value: s,
                          label: s,
                        }))
                  }
                  error={errors.state}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <GlobalDropdownField
                  name="city"
                  label="City *"
                  size="small"
                  value={formData.city}
                  onChange={handleInputChange}
                  placeholder="Select City"
                  options={cityList}
                  error={errors.city}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomInput
                  name="address"
                  title="Address *"
                  size="small"
                  placeholder="Enter Address"
                  value={formData.address}
                  onChange={handleInputChange}
                  error={errors.address}
                />
              </Grid>
            </Grid>
          </div>

          <div className={Styles.formstyling}>
            <span className="text-gray-500 text-[20px] font-bold">
              Profile Photo
            </span>
            <MinMaxFileUploader
              initialFiles={formData.profilePhoto}
              onFilesUpload={(urls) =>
                setFormData({ ...formData, profilePhoto: urls })
              }
              typeOfFilesAllowed="image/*"
              maxFiles={1}
            />
          </div>
        </form>
      </DialogContent>

      <DialogActions>
        <div className="w-30">
          <GlobalButton variant="secondary" size="medium" onClick={handleClose}>
            {`Close`}
          </GlobalButton>
        </div>
        <div className="w-30">
          <GlobalButton
            variant="primary"
            size="medium"
            isLoading={isLoading}
            onClick={handleSubmit}
          >
            {selectedUserData?._id ? "UPDATE" : "SAVE"}
          </GlobalButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default UserOnboardingForm;
